import { Outlet } from 'react-router-dom'
import image from '../assets/images/kobo-logo.png'
import { fullDate } from '../utils/date'
import styles from './Layout.module.css'

export const Layout = () => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.container}>
				<div className={styles.header}>
					<div className={`${styles.headerInfo} ${styles.headerInfoEnglish}`} dir="ltr">
						<strong>KOBO KOM TRADING COMPANY</strong>
						<span>Address: Syria - Qamishli - Caesarea Al Tujar</span>
						<span>TEL: 052438700</span>
						<span>WHATSAPP: 00963938994626</span>
						<span>EMAIL: <a href="mailto:contact_kobo.trade@gmail.com">contact_kobo.trade@gmail.com</a></span>
					</div>
					<div className={styles.logo}>
						<img src={image} alt='Kobo Trade' title='Kobo Trade' />
					</div>
					<div className={`${styles.headerInfo} ${styles.headerInfoArabic}`}>
						<strong>شركة كوبو كوم للتجارة العامة</strong>
						<span>العنوان: سوريا - القامشلي - قيصرية التجار</span>
						<span>الهاتف: 052438700</span>
						<span>واتس: 00963938994626</span>
						<span>السجل التجاري: 1858</span>
						<span>إيميل: <a href="mailto:contact_kobo.trade@gmail.com">contact_kobo.trade@gmail.com</a></span>
					</div>
				</div>
				<div className={styles.content}>
					<Outlet />
				</div>
				<div className={styles.footer}>
					<div className={`${styles.block} ${styles.dateBlock}`}>
						<p>
							<strong>التاريخ: </strong>
							<span dir="ltr">{fullDate(new Date())}</span>
						</p>
						<div className={styles.signatureSpace}>
							<span>التوقيع / الختم</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
